function parseDecimal(value: string): number
function parseDecimal(value?: string): number | undefined
function parseDecimal(value?: string): number | undefined {
  if (value === undefined || value === '') {
    return undefined
  }

  const result = Number(value.replace(/\s/g, '').replace(',', '.'))
  if (Number.isNaN(result)) {
    throw new Error(`Unable to parse ${String(value)} as a number`)
  }

  return result
}

function parseKwToW(kw: string): number
function parseKwToW(kw?: string): number | undefined
function parseKwToW(kw?: string): number | undefined {
  return kw !== undefined ? parseDecimal(kw) * 1000 : undefined
}

function parsePercentToDecimal(value: string): number
function parsePercentToDecimal(value?: string): number | undefined
function parsePercentToDecimal(value?: string): number | undefined {
  return value ? parseDecimal(value) / 100 : undefined
}

export { parseDecimal, parseKwToW, parsePercentToDecimal }
